import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {'rejectionReason': ''};
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  handleReasonChange(event) {
    this.setState({'rejectionReason': event.target.value});
  }

  handleDeleteClick() {
    const {orderToDelete, indexToDelete} = this.props;
    const {rejectionReason} = this.state;

    if (rejectionReason && orderToDelete && indexToDelete !== null) {
      const data = {'partCode': orderToDelete.partCode, rejectionReason};
      this.props.deleteProviderOrderDetail(orderToDelete.orderCode, data, indexToDelete);
      this.props.clearSelectedProviderOrderDetailElement();
    }
  }

  handleCancelClick() {
    this.props.clearSelectedProviderOrderDetailElement();
    this.setState({'rejectionReason': ''});
  }

  render() {
    const {orderToDelete, indexToDelete} = this.props;
    const shouldShow = !!orderToDelete && indexToDelete !== null;

    return (
      <Modal
        size='small'
        trigger={<span />}
        open={shouldShow}
        onClose={this.handleCancelClick}
      >
        <Modal.Header>
          ¿Desea eliminar la línea del Pedido?
        </Modal.Header>
        <Modal.Content>
          <label><strong>Razón de eliminación</strong></label>
          <Input fluid
            error={!this.state.rejectionReason}
            maxLength='100'
            placeholder='Justificación de la eliminación...'
            value={this.state.rejectionReason}
            onChange={this.handleReasonChange}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCancelClick}>CANCELAR</Button>
          <Button primary onClick={this.handleDeleteClick}>ELIMINAR</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'orderToDelete': state.providersOrdersManagementDetail.orderToDelete,
    'indexToDelete': state.providersOrdersManagementDetail.indexToDelete,
  };
};

const {
  deleteProviderOrderDetail,
  clearSelectedProviderOrderDetailElement,
} = Actions;

export default connect(mapStateToProps, {
  deleteProviderOrderDetail,
  clearSelectedProviderOrderDetailElement,
})(DeleteModal);
